const concat = (...parts: Uint8Array[]) => {
  const size = parts.reduce((total, part) => total + part.length, 0);
  const result = new Uint8Array(size);
  let offset = 0;
  for (const part of parts) {
    result.set(part, offset);
    offset += part.length;
  }
  return result;
};

const varint = (input: number) => {
  let value = Math.max(0, Math.round(input)) >>> 0;
  const bytes: number[] = [];
  do {
    let byte = value & 0x7f;
    value >>>= 7;
    if (value) byte |= 0x80;
    bytes.push(byte);
  } while (value);
  return Uint8Array.from(bytes);
};

const integer = (field: number, value: number) => value === 0
  ? new Uint8Array()
  : concat(varint(field << 3), varint(value));

const bytes = (field: number, value: Uint8Array) => concat(
  varint((field << 3) | 2), varint(value.length), value,
);

const string = (field: number, value: string) => bytes(field, new TextEncoder().encode(value));

export const encodeMouseInput = (x: number, y: number, buttons: number) => {
  const mouse = concat(integer(1, x), integer(2, y), integer(3, buttons));
  return bytes(3, mouse); // InputEvent.mouse_event
};

export const encodeKeyboardInput = (key: string, eventType: 0 | 1 | 2) => {
  const keyboard = concat(integer(2, eventType), string(4, key));
  return bytes(1, keyboard); // InputEvent.key_event
};

export interface DirectTouch {
  x: number;
  y: number;
  identifier: number;
  pressure: number;
  touchMajor?: number;
  touchMinor?: number;
}

export const encodeTouchInput = (touches: DirectTouch[]) => {
  const touchMessages = touches.map((touch) => bytes(1, concat(
    integer(1, touch.x),
    integer(2, touch.y),
    integer(3, touch.identifier),
    integer(4, touch.pressure),
    integer(5, touch.touchMajor || 0),
    integer(6, touch.touchMinor || 0),
  )));
  return bytes(2, concat(...touchMessages)); // InputEvent.touch_event
};
